import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import LatLong from "../../rest/jtmc/models/LatLong";
import {askLocation} from "../../helpers";
import DeliveryAddress from "../../rest/jtmc/models/DeliveryAddress";
import {goBack} from "../../refrences/RootNavigation";

interface state {
    isEdit: boolean,
    id: number,
    address: string,
    phone: string,
    client_name: string,
    title: string,
    latlong: {
        lat: number,
        long: number
    }
}

interface props {
    inputAddress: DeliveryAddress | undefined | null,
    children: any
}

class AddressEditComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
        this.state = {
            isEdit: props.inputAddress != null,
            id: props.inputAddress?.id ?? 0,
            address: props.inputAddress?.address ?? "",
            phone: props.inputAddress?.phone ?? "",
            client_name: props.inputAddress?.clientName ?? "",
            title: props.inputAddress?.title ?? "",
            latlong: props.inputAddress?.latlong ?? {
                lat: 35.8,
                long: 51
            }
        }
    }

    save() {
        this.fetch.Order.requests.addOrEditAddress({
            title: this.state.title,
            name: this.state.client_name,
            phone: this.state.phone,
            address: this.state.address,
            latlong: JSON.stringify({
                lat: this.state.latlong.lat,
                long: this.state.latlong.long
            }),
            id: this.state.id
        }).then(res => {
            goBack();
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const errorSnack = this.appContext.snackBarData?.events?.error;
        if (!this.state.isEdit)
            askLocation(errorSnack).then(loc => {
                this.setState({
                    latlong: new LatLong({
                        lat: loc.coords.latitude,
                        long: loc.coords.longitude
                    })
                })
            }).catch(r => {
                if (errorSnack) errorSnack("خطا در دریافت موقعیت کنونی");
            });
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "map",
                visible: true,
                props: {
                    function: "locationSelect",
                    defaultLocation: new LatLong({lat: this.state.latlong?.lat, long: this.state.latlong?.long}),
                    onLocationSelect: (ll: LatLong) => {
                        this.setState({
                            latlong: ll
                        });
                    },
                },
                children: null,
            },
            {
                role: "input-title",
                visible: true,
                props: {
                    label: "عنوان آدرس",
                    value: this.state.title,
                    placeholder: "مثال: خانه، یا محل کار",
                    onChangeText: (t: string) => this.setState({title: t})
                },
                children: null,
            },
            {
                role: "input-name",
                visible: true,
                props: {
                    label: "نام تحویل گیرنده",
                    value: this.state.client_name,
                    placeholder: "نام و نام خانوادگی",
                    onChangeText: (t: string) => this.setState({client_name: t})
                },
                children: null,
            },
            {
                role: "input-phone",
                visible: true,
                props: {
                    label: "شماره تحویل گیرنده",
                    value: this.state.phone,
                    placeholder: "شماره موبایل",
                    onChangeText: (t: string) => this.setState({phone: t})
                },
                children: null,
            },
            {
                role: "input-address",
                visible: true,
                props: {
                    label: "نشانی دقیق",
                    value: this.state.address,
                    placeholder: "آدرس دقیق",
                    onChangeText: (t: string) => this.setState({address: t})
                },
                children: null,
            },
            {
                role: "button-save",
                visible: true,
                props: {
                    title: "ذخیره آدرس و بازگشت",
                    onPress: ()=>{
                        this.save()
                    }
                },
                children: null,
            },
        ];
    }

}

export default AddressEditComponents;